module.exports = __webpack_public_path__ + "static/img/我查查_300×300.6bb8f383.png";